if (window?.Shopify && !Shopify?.designMode) {
  (() => {
    const path = window.location.pathname;

    const isAllowed =
      path === "/" ||
      path.includes("/products") ||
      path.includes("/account") ||
      path.includes("/cart") ||
      path.includes("/store-details") ||
      path.includes("/collections/all") ||
      path.includes("/password");

    if (!isAllowed) {
      window.location.href = "/";
    }
  })();
}

const stickyHeader = document.querySelector("sticky-header");
const headerIconsBlock = document.querySelector(".header__icons");
const megaMenuWrapper = document.querySelector(".header__mega-menu-wrapper");
const openMegaMenuButtons = document.querySelectorAll("[data-open-megamenu]");
const megaMenus = document.querySelectorAll(`[data-megamenu]`);
// window.addEventListener("scroll", () => {
//   closeMegaMenu();
//   if (stickyHeader.clientHeight <= window.scrollY) {
//     stickyHeader.classList.remove("header-wrapper--transparent");
//   } else {
//     stickyHeader.classList.add("header-wrapper--transparent");
//   }
// });
// openMegaMenuButtons.forEach((btn) => {
//   btn.addEventListener("mouseover", () =>
//     btn.dataset.openMegamenu ? openMegaMenu(btn) : closeMegaMenu()
//   );
// });

// if (megaMenuWrapper)
//   megaMenuWrapper.addEventListener("mouseleave", closeMegaMenu);

// function closeMegaMenu() {
//   if (stickyHeader.clientHeight > window.scrollY) {
//     stickyHeader.classList.add("header-wrapper--transparent");
//   }
//   if (megaMenuWrapper) megaMenuWrapper.classList.remove("active");
// }
// function openMegaMenu(btn) {
//   stickyHeader.classList.remove("header-wrapper--transparent");
//   const menu = document.querySelector(
//     `[data-megamenu="${btn.dataset.openMegamenu}"]`
//   );
//   if (!menu) return;
//   megaMenuWrapper.classList.add("active");
//   megaMenus.forEach((menu) => menu.classList.remove("is-open"));
//   menu.classList.add("is-open");
// }
// const headerBlocks = document.querySelectorAll("sticky-header .header > *");

// headerBlocks.forEach((item) => {
//   item.addEventListener(
//     "mouseover",
//     () => {
//       stickyHeader.classList.add("active");
//     },
//     true
//   );
// });

const headerIcons = [
  {
    modal: document.querySelector(".header__search"),
    trigger: document.querySelector(".header__search"),
  },
  {
    modal: document.querySelector("#account-modal"),
    trigger: document.querySelector("#account-click-trigger"),
  },
  {
    modal: document.querySelector("cart-notification"),
    trigger: document.querySelector("#cart-icon-bubble"),
  },
];

headerIcons.forEach((item) => {
  if (item.trigger)
    item.trigger.addEventListener("mouseover", (e) => {
      e.stopPropagation();
      headerIcons.forEach((el) => el?.modal && el.modal.close());
    });

  if (stickyHeader)
    stickyHeader.addEventListener("mouseover", (e) => {
      e.stopPropagation();
      if (
        item?.modal?.querySelectorAll("*") &&
        Array.from(item.modal.querySelectorAll("*")).every(
          (el) => e.target !== el
        ) &&
        e.target !== item.trigger &&
        e.target !== stickyHeader.querySelector(".header")
      )
        item.modal.close();
    });
});
if (stickyHeader)
  stickyHeader.addEventListener("mouseleave", () => {
    headerIcons.forEach((el) => el?.modal && el.modal.close());
    closeMegaMenu();
  });

Shopify.money_format = "£{{amount}}";
Shopify.formatMoney = function (cents, format) {
  const currency = Shopify.currency?.active || "";
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

let globalCartItems = (async () => {
  const res = await fetch("/cart.js");
  const cart = await res.json();
  return cart.items;
})();

async function checkAddedProductInCart(elem, productId) {
  const cartItems = await globalCartItems;
  if (
    cartItems.find(
      (item) => item.product_id === productId || item.id === productId
    )
  ) {
    elem.classList.add("added");
  }
}
function checkAddedProductInWishlist(elem, productId) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(() => {
    _swat.fetchWrtEventTypeET((products) => {
      if (products.some((product) => product.empi === productId)) {
        elem.classList.add("filled");
      }
    });
  });
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function addAndRemoveClass(items = [], activeItem, nameClass = "active") {
  Array.from(items)
    .filter((el) => el !== activeItem)
    .forEach((item) =>
      setTimeout(() => {
        item.classList.remove(nameClass);
      }, 200)
    );
  const activeElem = Array.from(items).find((item) => item === activeItem);
  if (activeElem) activeElem.classList.toggle(nameClass);
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }
  summary.addEventListener("click", (event) => {
    if (document.body.classList.contains("template-product")) {
      stickyHeader.classList.add("background-field");
    }
    if (event.currentTarget.closest("details").hasAttribute("open")) {
      stickyHeader.classList.remove("background-field");
    }
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class AddToCartBanner extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (e) => {
      if (!e.target.classList.contains("add-to-cart-banner__container"))
        this.close();
    });
  }
  async updateCount() {
    const res = await fetch(
      `${window.location.pathname}?section_id=cart-icon-bubble`
    );
    const html = await res.text();
    document.querySelectorAll(".header__icon--cart").forEach((el) => {
      el.innerHTML = html;
    });
  }
  open() {
    this.updateCount();
    this.classList.add("is-open");
    setTimeout(() => {
      this.close();
    }, 3000);
  }
  close() {
    this.classList.remove("is-open");
    document.body.classList.remove("overflow");
  }
}
customElements.define("add-to-cart-banner", AddToCartBanner);

class SpendingProductLimit extends HTMLElement {
  constructor() {
    super();
    this.data = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );

    this.productLimit = this.data.productLimit;
    this.spendingLimit = this.data.spendingLimit;
    this.spendingLimitModal = document.querySelector(".spending-limit-modal");
    this.productLimitModal = document.querySelector(".product-limit-modal");
    this.modalButton = document.querySelectorAll(
      ".modal-limit .btn, .modal-limit .modal-limit__close-btn"
    );
    this.cartForm = document.querySelector("#cart");
    this.charityPopup = document.querySelector(".charity-popup");
    this.closeTriggers = document.querySelectorAll(
      ".charity-popup__overlay, .charity-popup__close"
    );
    this.cartFormButtons = document.querySelectorAll(".cart__checkout-button");
    this.exceededLimitsCorrect = this.parseLimits(this.data.exceededLimits);
    this.skuExceededLimitsCorrect = this.parseLimits(
      this.data.skuExceededLimits
    );
    this.skuExceededLimitsCounter = this.skuExceededLimitsCorrect.reduce(
      (acc, option) => {
        return {
          ...acc,
          [option.name]: (acc[option.name] || 0) + option.count,
        };
      },
      {}
    );
    this.skuExceededLimitsArr = Object.entries(this.skuExceededLimitsCounter)
      .map((item) => ({
        name: item[0],
        count: item[1],
      }))
      .filter((item) => item.count > this.data.anotherProductCount)
      .map((item) => ({
        name: item.name,
        count: item.count - this.data.anotherProductCount,
      }));

    if (this.skuExceededLimitsArr.some((item) => item.count > 0)) {
      this.productLimit = true;
    }

    this.uniqExceeded = [
      ...new Map(
        this.exceededLimitsCorrect
          .concat(this.skuExceededLimitsArr)
          .map((item) => [item.name, item])
      ).values(),
    ];

    if (this.closeTriggers.length) {
      this.closeTriggers.forEach((button) =>
        button.addEventListener("click", this.closeCharityPopup.bind(this))
      );
    }
    if (window.location.hash.includes("productLimit")) {
      this.openModal();
    }
    if (
      (this.productLimit && window.location.href.includes("checkouts")) ||
      (this.spendingLimit && window.location.href.includes("checkouts"))
    ) {
      window.location.href = "/cart#productLimit";
    }

    this.modalButton.forEach((button) =>
      button.addEventListener("click", this.hideModal)
    );

    if (this.cartFormButtons.length > 0) {
      this.cartFormButtons.forEach((button) => {
        button.addEventListener("click", (e) => this.handleFormCart(e));
      });
    }
  }

  parseLimits(limits) {
    if (!limits) return [];
    return limits.map((item) => {
      return {
        name: item.split(":")[0],
        count: +item.split(":")[1],
      };
    });
  }

  hideModal() {
    this.closest(".modal-limit").classList.remove("active");
  }

  openModal() {
    const infowWrapper = document.querySelector("[data-spend-limit-name]");
    if (this.productLimit) {
      infowWrapper.innerHTML = `<ul>
        ${this.uniqExceeded
          .map(
            (item) => `
          <li>${item.count}
            ${
              Number(item.name)
                ? `<span class="text-body">products with the same article number</span>
                      <span class="text-body-medium">${item.name}(***)</span>`
                : item.name
            }
          </li>
        `
          )
          .join("")}
      </ul>`;
      this.productLimitModal.classList.add("active");
    } else if (this.spendingLimit) {
      this.spendingLimitModal.classList.add("active");
    } else {
      return;
    }
  }
  async handleFormCart(e) {
    e.preventDefault();
    const customerTags = document.querySelector('[name="attributes[tags]"]');
    const companyLocationsCounter = document.querySelector(
      '[name="attributes[companyLocationsCounter]"]'
    );
    const customerAddress = document.querySelector(
      '[name="attributes[address]"]'
    );
    const agreeInput = e.target.closest(".cart__ctas").querySelector("input");
    const formElement = e.target
      .closest(".cart__ctas")
      .querySelector(".agree-block");

    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          tags: customerTags ? customerTags.value : "",
          address: customerAddress ? customerAddress.value : "",
          companyLocationsCounter: companyLocationsCounter
            ? companyLocationsCounter.value
            : "",
        },
      }),
    }).then((res) => {
      if (res.status === 200) {
        if (
          this.charityPopup &&
          this.charityPopup.classList.contains("no-open")
        ) {
          e.preventDefault();
          this.openCharityPopup();
          return false;
        }

        if (!agreeInput.checked) {
          e.preventDefault();
          formElement.classList.add("error");
        } else {
          formElement.classList.remove("error");
          if (this.productLimit || this.spendingLimit) {
            e.preventDefault();
            this.openModal();
          } else {
            if (this.data.discountCode) {
              window.location.href =
                "/checkout?discount=" + this.data.discountCode;
            } else {
              window.location.href = "/checkout";
            }
          }
        }
      }
    });
  }

  openCharityPopup() {
    this.charityPopup.classList.add("active");
  }
  closeCharityPopup() {
    this.charityPopup.classList.remove("no-open", "active");
  }
}
customElements.define("spending-product-limit", SpendingProductLimit);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.cartMain = this.closest("cart-items");
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  async updateTemplate(state, callback) {
    const parsedState = JSON.parse(state);
    const sectionsForUpdates = this.cartMain.getSectionsToRender();
    const spendUpdate = await fetch(
      window.location.pathname + "?sections=account-modal"
    );
    const spendHtml = await spendUpdate.json();
    parsedState.sections["account-modal"] = spendHtml["account-modal"];
    sectionsForUpdates.push({
      id: "account-modal-target",
      section: "account-modal",
      selector: ".shopify-section",
    });
    sectionsForUpdates.forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);
      if (!elementToReplace) return;
      elementToReplace.innerHTML = this.cartMain.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });
    this.cartMain.disableLoading();
    callback();
  }
  async onButtonClick(event) {
    event.preventDefault();
    this.closest("cart-items").enableLoading(this.input.dataset.index);

    const previousValue = this.input.value;
    const selector = event.target.dataset?.relatedProduct?.split(":") || [];
    selector[0] = selector[1];
    selector[1] = event.target.dataset.id;
    const personProduct = document.querySelector(
      `.cart-item [data-personalisation-product="${selector.join(":")}"]`
    );

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    const updateProducts = {
      updates: {
        [event.target.dataset.key]: this.input.value,
        ...(personProduct && {
          [personProduct.dataset.key]: this.input.value,
        }),
      },
    };

    let errorMessage = "";
    if (previousValue !== this.input.value) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...updateProducts,
          sections: this.cartMain
            .getSectionsToRender()
            .map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      })
        .then((res) => res.text())
        .then((state) => {
          errorMessage = JSON.parse(state).message;
          if(errorMessage) {
            throw new Error(errorMessage);
          }
          this.updateTemplate(state)
        })
        .catch(() => {
          const sectionIds = this.cartMain.getSectionsToRender().map((section) => section.section).join(",");
          Promise.all([
            fetch("/cart.js").then((res) => res.json()),
            fetch(`/cart?sections=${sectionIds}`).then((res) => res.json()),
          ])
            .then(([cart, sections]) => {
              this.updateTemplate(JSON.stringify({
                ...cart,
                sections,
              }), () => {
                if (errorMessage && document.getElementById("cart-errors")) {
                  document.getElementById("cart-errors").textContent = errorMessage;
                }
              })
            })
            .catch((err) => {
              console.error("Error fetching cart or sections:", err);
            })
        });
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".section-header");
    this.mainDetailsToggle = this.querySelector("details");
    this.overlay = this.querySelector(".menu-drawer__overlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    if (this.overlay)
      this.overlay.addEventListener("click", (e) => this.closeMenuDrawer(e));

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      this.header.classList.remove("menu-open");
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class ImagesPopup extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.swiperThumbs = null;
    this.zoomImmediately = false;
    this.popup = document.querySelector(".images-popup");
    this.popupClose = document.querySelectorAll(
      ".images-popup__overlay, .images-popup__close"
    );
    this.initSlider();
    this.customCursor = document.querySelector(".zoom-text-cursor");
    this.swiper.slides.forEach((slide) => {
      slide.firstElementChild.addEventListener("mousemove", (e) => {
        const img = slide.getBoundingClientRect();
        const cursorXrelativeToImg = e.clientX - img.left;
        const cursorYrelativeToImg = e.clientY - img.top;
        this.customCursor.style.transform = `translate(${
          e.clientX - img.left - 25
        }px, ${e.clientY - 11}px)`;
        if (slide.classList.contains("zoomed-in") && 989 < window.innerWidth) {
          const cursorXratio = cursorXrelativeToImg / slide.offsetWidth;
          const cursorYratio = cursorYrelativeToImg / slide.offsetHeight;
          const imgX = slide.offsetWidth / 2 - cursorXratio * slide.offsetWidth;
          const imgY =
            slide.offsetHeight / 2 - cursorYratio * slide.offsetHeight;
          slide
            .querySelector(".swiper-zoom-container")
            .querySelector(".swiper-zoom-target").style.transition = "none";
          slide
            .querySelector(".swiper-zoom-container")
            .querySelector(
              ".swiper-zoom-target"
            ).style.transform = `translate3d(${imgX}px, ${imgY}px, 0) scale(2)`;
        }
      });
      slide.firstElementChild.addEventListener("mouseout", (e) => {
        this.customCursor.style.transform = `translate(-100px, -100px)`;
      });
      slide.firstElementChild.addEventListener("click", (e) => {
        if (slide.classList.contains("zoomed-in"))
          this.customCursor.innerHTML = "Zoom in";
        else this.customCursor.innerHTML = "Zoom out";
      });
    });

    document.addEventListener("click", (e) => {
      if (e.target.dataset.productImage) {
        this.zoomImmediately = e.target.dataset.zoomImmediately;
        this.settingsSlider(e.target);
        this.openPopup();
      }
    });
    this.popupClose.forEach((item) => {
      item.addEventListener("click", () => {
        this.closePopup();
      });
    });
    this.swiper.$el[0].addEventListener("click", (e) => {
      if (this.zoomImmediately) {
        this.closePopup();
      } else {
        this.swiper.zoom.toggle();
      }
    });
  }
  openPopup() {
    this.popup.classList.add("images-popup--is-open");
  }
  closePopup() {
    this.popup.classList.remove("images-popup--is-open");
    this.swiper.zoom.out();
  }
  settingsSlider(item) {
    if (this.swiper.$el[0].classList.contains("swiper-images")) {
      this.swiper.slideTo(+item.dataset.index);
      if (this.zoomImmediately) {
        this.swiper.zoom.in();
      }
    }
  }
  initSlider() {
    const counter = document.querySelectorAll(".counter-slider");
    this.swiperThumbs = new Swiper(".swiper-thumbs", {
      spaceBetween: 10,
      slidesPerView: 10,
      centerInsufficientSlides: true,
    });
    this.swiper = new Swiper(".swiper-images", {
      loop: true,
      effect: "slide",
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true,
      },
      zoom: {
        maxRatio: 2,
        toggle: false,
        zoomedSlideClass: "zoomed-in",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: this.swiperThumbs,
      },
      breakpoints: {
        989: {
          allowTouchMove: true,
        },
      },
      on: {
        init: function () {
          counter.forEach(
            (el) =>
              (el.innerHTML =
                this.realIndex + 1 + "/" + (this.slides.length - 2))
          );
        },
        slideChange: function () {
          counter.forEach(
            (el) =>
              (el.innerHTML =
                this.realIndex + 1 + "/" + (this.slides.length - 2))
          );
        },
        slideChangeTransitionEnd: function () {
          this.zoom.enable();
        },
        slideChangeTransitionStart: function () {
          this.zoom.disable();
          this.zoom.out();
        },
      },
    });
  }
}
customElements.define("images-popup", ImagesPopup);

class ZoomModalTrigger extends HTMLElement {
  constructor() {
    super();
    this.src = this.querySelector("img")?.src;
    this.zoomModal = document.querySelector(".image-zoom-modal");
    this.addEventListener("click", this.open.bind(this));
    this.customCursor = document.querySelector(".zoom-text-cursor");

    this.addEventListener("mousemove", (e) => {
      if (this.customCursor && !this.customCursor?.classList?.contains("show"))
        this.customCursor.classList.add("show");
      this.customCursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    });
    this.addEventListener("mouseleave", (e) => {
      if (!this.zoomModal.classList.contains("active"))
        this.customCursor.classList.remove("show");
    });
  }
  open(e) {
    e.preventDefault();
    e.stopPropagation();
    this.zoomModal.open(this.src);
  }
}
customElements.define("zoom-modal-trigger", ZoomModalTrigger);
class ImageZoomModal extends HTMLElement {
  constructor() {
    super();
    this.zoomImage = this.querySelector("[data-zoom-image]");
    this.closeBtn = this.querySelector(".image-zoom-modal__button");
    this.customCursor = document.querySelector(".zoom-text-cursor");
    this.zoomImageSlider = new Swiper(".swiper-zoom-image", {
      zoom: {
        maxRatio: 2,
        toggle: false,
        zoomedSlideClass: "zoomed-in",
      },
    });
    this.addEventListener("click", this.close.bind(this));
    if (window.innerWidth > 989) {
      this.addEventListener("mousemove", (e) => {
        if (e.target === this.closeBtn) {
          this.customCursor.innerHTML = "";
        } else if (
          this.customCursor.innerHTML === "" &&
          e.target !== this.closeBtn
        ) {
          this.customCursor.innerHTML = "Zoom Out";
        }
        this.customCursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
        const img = this.getBoundingClientRect();
        const cursorXrelativeToImg = e.clientX - img.left;
        const cursorYrelativeToImg = e.clientY - img.top;
        const cursorXratio = cursorXrelativeToImg / this.offsetWidth;
        const cursorYratio = cursorYrelativeToImg / this.offsetHeight;
        const imgX = this.offsetWidth / 2 - cursorXratio * this.offsetWidth;
        const imgY = this.offsetHeight / 2 - cursorYratio * this.offsetHeight;
        this.zoomImage.style.transform = `translate3d(${imgX}px, ${imgY}px, 0) scale(2)`;
      });
    }
  }
  open(src) {
    this.zoomImage.style.background = `url(${src})no-repeat center/contain`;
    this.zoomImageSlider.zoom.in();
    document.body.classList.add("overflow");
    this.customCursor.innerHTML = "Zoom Out";
    this.classList.add("active");
  }
  close() {
    this.classList.remove("active");
    this.customCursor.innerHTML = "Zoom In";
    document.body.classList.remove("overflow");
  }
}
customElements.define("image-zoom-modal", ImageZoomModal);

const swiper = new Swiper(".swiper-announcement", {
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const productImagesMobileSlider = new Swiper(".product-images-mobile", {
  loop: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  on: {
    init: function () {
      const counter = document.querySelectorAll(".counter-slider-mobile");
      counter.forEach(
        (el) =>
          (el.innerHTML = this.realIndex + 1 + "/" + (this.slides.length - 2))
      );
    },
    slideChange: function () {
      const counter = document.querySelectorAll(".counter-slider-mobile");
      counter.forEach(
        (el) =>
          (el.innerHTML = this.realIndex + 1 + "/" + (this.slides.length - 2))
      );
    },
  },
});

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.mobileSelectSize = this.querySelector("select.select-Size");
    this.availableMwssage = document.querySelectorAll(
      ".product [data-available-quantity]"
    );
    this.addToCartBtns = document.querySelectorAll("add-to-cart");
    this.firstAvailabelVariantData = document
      .querySelector(".product [data-first-available-variant]")
      .value.split(", ");
    this.firstAvailabelVariant = {
      id: +this.firstAvailabelVariantData[0],
      inventory_quantity: +this.firstAvailabelVariantData[1],
      option1: this.firstAvailabelVariantData[2],
    };

    // this.getCartItem(this.firstAvailabelVariant);
    this.addEventListener("change", this.onVariantChange);

    if (this.mobileSelectSize) {
      this.mobileSelectSize.value = "";
      this.toggleAddButton(true, "Choose a size", false);
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.getCartItem(this.currentVariant);
      document
        .querySelectorAll('[name="add"]')
        .forEach((btn) => btn.classList.remove("in-cart"));

      this.addToCartBtns.forEach((btn) => {
        btn.dataset.id = this.currentVariant.id;
        btn.classList.add("active");
        btn.classList.remove("added-to-cart");
        btn
          .querySelectorAll(".btn__text")
          .forEach((txt) => (txt.textContent = "Add to Cart"));
      });
      document.querySelectorAll("add-to-wishlist").forEach((btn) => {
        btn.dataset.variantId = this.currentVariant.id;
        btn.checkWishList(this.currentVariant.id, btn);
      });
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index].toLowerCase() === option.toLowerCase();
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );

    if (mediaGallery) {
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );
    }

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );

    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const sectionId = this.dataset.section.replace("_2", "");
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${sectionId}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const priceBlocks = source.querySelectorAll("[data-product-price]");
        const personalisationInput = document.querySelector(
          "#personalisationInput"
        );
        if (personalisationInput && personalisationInput.value.length === 3) {
          priceBlocks.forEach(
            (el) =>
              (el.textContent = Shopify.formatMoney(
                +el.dataset.productPrice + +personalisationInput.dataset.price
              ))
          );
        }
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${sectionId}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > .btn-text');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  async getCartItem(currentVariant) {
    const addButtons = document.querySelectorAll('[name="add"], add-to-cart');
    const res = await fetch("/cart.js");
    const cart = await res.json();
    const cartItem = cart.items.find((item) => item.id === currentVariant.id);

    this.availableMwssage.forEach((el) => (el.innerHTML = ""));
    if (currentVariant) {
      addButtons.forEach((btn) => btn.classList.remove("disabled"));
      if (currentVariant.inventory_quantity - cartItem?.quantity === 0) {
        this.availableMwssage.forEach(
          (el) =>
            (el.innerHTML = `All items in size ${currentVariant.option1} have been added to the cart`)
        );
        addButtons.forEach((btn) => {
          btn.classList.add("added-to-cart", "disabled");
          btn
            .querySelectorAll(".btn__text")
            .forEach((txt) => (txt.textContent = "In Cart"));
        });
      } else if (
        currentVariant.inventory_quantity - cartItem?.quantity === 1 ||
        currentVariant.inventory_quantity === 1
      ) {
        this.availableMwssage.forEach((el) => (el.innerHTML = "Only 1 left"));
      } else {
        addButtons.forEach((btn) => {
          btn.classList.remove("added-to-cart", "disabled");
          btn
            .querySelectorAll(".btn__text")
            .forEach((txt) => (txt.textContent = "Add to Cart"));
        });
      }
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class addToWishListModal extends HTMLElement {
  constructor() {
    super();
    this.productData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    this.modal = document.querySelector(".add-to-wishlist-modal");
    this.contentWrapper = this.modal.querySelector(
      "[data-content-wishlist-modal]"
    );
    this.closeButtons = this.modal.querySelectorAll("[data-close-modal]");
    this.button = this.modal.querySelector("[add-to-wishlist]");
    this.buttonText = this.modal.querySelector("[add-to-wishlist] .btn-text");
    checkAddedProductInWishlist(this, this.productData.productId);
    this.addEventListener("click", (e) => {
      if (
        this.productData.variants.filter((variant) => variant.available)
          .length === 1
      ) {
        const wishProduct = {
          epi: this.productData.variants.find((variant) => variant.available)
            ?.id,
          empi: this.productData.productId,
          ct: this.productData.productType,
        };
        this.add(wishProduct);
      } else {
        this.contentWrapper.innerHTML = this.renderVariants();
        this.variants = this.modal.querySelectorAll("[data-variant-id]");
        this.variants.forEach((variant) => {
          this.checkAddedToWishList(variant);
          variant.addEventListener("click", () => this.chooseVariant(variant));
        });
        this.modal.classList.add("active");

        this.button.addEventListener("click", (e) => {
          e.preventDefault();
          const choosedVariant = Array.from(this.variants).find((variant) =>
            variant.classList.contains("active")
          );
          const wishProduct = {
            epi: +choosedVariant.dataset.variantId,
            empi: +choosedVariant.dataset.productId,
            ct: choosedVariant.dataset.productType,
          };
          this.add(wishProduct, choosedVariant);
        });
      }
      this.closeButtons.forEach((button) =>
        button.addEventListener("click", () =>
          this.modal.classList.remove("active")
        )
      );
    });
  }

  sortingSize(a, b) {
    const sizes = productSortedSizes;
    const aIdx = sizes.indexOf(a.option1.toUpperCase());
    const bIdx = sizes.indexOf(b.option1.toUpperCase());
    if (aIdx < 0 && bIdx < 0) {
      return a.option1 - b.option1;
    }
    return aIdx - bIdx;
  }
  renderVariants() {
    const filteredVariants = this.productData.variants.filter(
      (variant) => variant.available
    );
    return filteredVariants
      .sort(this.sortingSize.bind(this))
      .map((variant, index) => {
        return `
      <div class="add-to-wishlist-modal__variant" 
        data-product-id="${this.productData.productId}" 
        data-product-type="${this.productData.productType}"  
        data-variant-id="${variant.id}">
        ${variant.option1}
      </div>
    `;
      })
      .join("");
  }
  chooseVariant(variant) {
    addAndRemoveClass(this.variants, variant);
    if (
      Array.from(this.variants).find((variant) =>
        variant.classList.contains("active")
      )
    ) {
      this.buttonText.textContent = "Select";
      this.button.classList.remove("disabled", "added-to-wishlist");
    } else {
      this.button.classList.add("disabled", "added-to-wishlist");
    }
  }
  checkAddedToWishList(variant) {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(() => {
      _swat.fetchWrtEventTypeET((products) => {
        if (
          products.find((product) => product.epi == variant.dataset.variantId)
        ) {
          variant.classList.add("added-to-wishlist");
          this.buttonText.textContent = "Added";
          this.button.classList.add("disabled", "added-to-wishlist");
        }
      });
    });
  }
  add(wishProduct, choosedVariant) {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    choosedVariant && this.button.classList.add("loading");
    window._swat.addToWishList(
      { ...wishProduct },
      (res) => {
        this.classList.add("filled");
        if (window.location.pathname === "/pages/favourites") {
          this.updateWishList();
        }
        if (choosedVariant) {
          choosedVariant.classList.add("added-to-wishlist");
          this.buttonText.textContent = "Added";
          this.button.classList.add("disabled", "added-to-wishlist");
          this.button.classList.remove("loading");
          setTimeout(() => {
            this.modal.classList.remove("active");
            this.buttonText.textContent = "Select";
            this.button.classList.remove("added-to-wishlist");
          }, 300);
        }
      },
      (error) => {
        console.log("There was an error adding the product to wishlist", error);
      }
    );
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  async updateWishList() {
    const wishList = await fetch("/?sections=wish-list");
    const datawishList = await wishList.json();
    document.getElementById(`${Object.keys(datawishList)[0]}`).innerHTML =
      this.getSectionInnerHTML(
        Object.values(datawishList)[0],
        `#${Object.keys(datawishList)[0]}`
      );
    new WishList();
  }
}

customElements.define("add-to-wishlist-modal", addToWishListModal);

class addToWishList extends HTMLElement {
  constructor() {
    super();
    this.isIcon = this.dataset.onlyIcon;
    this.btnText = this.querySelector("[data-btn-text]");
    this.checkWishList(+this.dataset.productId);
    this.addEventListener("click", (e) => {
      e.preventDefault();
      if (this.classList.contains("added-to-wishlist")) {
        this.remove();
      } else {
        this.add();
      }
    });
  }
  checkWishList(variantId) {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(() => {
      _swat.fetchWrtEventTypeET((products) => {
        if (products.some((product) => product.empi === variantId)) {
          this.classList.add("added-to-wishlist", "btn--primary");
          this.classList.remove("btn--secondary");
        } else {
          this.classList.remove("added-to-wishlist", "btn--primary");
          this.classList.add("btn--secondary");
        }
      });
    });
  }
  add() {
    window._swat.addToWishList(
      {
        epi: +this.dataset.variantId,
        empi: +this.dataset.productId,
        ct: this.dataset.productType,
      },
      () => {
        this.classList.add("added-to-wishlist", "btn--primary", "animation");
        this.classList.remove("btn--secondary");
        if (!this.isIcon) {
          this.classList.add("loading");
        }
        setTimeout(() => {
          this.classList.remove("loading", "animation");
        }, 500);
        if (window.location.pathname.includes("favourites")) {
          new WishList();
        }
      }
    );
  }
  remove(id = null) {
    window.SwymCallbacks.push(() => {
      _swat.removeFromWishList(
        {
          epi: id ? id : +this.dataset.variantId,
        },
        (r) => {
          if (!this.isIcon) {
            this.classList.add("loading");
          }
          this.classList.remove("added-to-wishlist", "btn--primary");
          this.classList.add("btn--secondary", "animation");

          setTimeout(() => {
            this.classList.remove("loading", "animation");
          }, 500);
          if (window.location.pathname.includes("favourites") && !id) {
            new WishList(
              JSON.parse(
                document.querySelector(
                  '[data-wish-settings][type="application/json"]'
                ).textContent
              )
            );
          }
        }
      );
    });
  }
}
customElements.define("add-to-wishlist", addToWishList);

class addToCart extends HTMLElement {
  constructor() {
    super();
    this.btnText = this.querySelector("[data-btn-text");
    this.addEventListener("click", this.add);
  }
  async add() {
    this.classList.add("loading");
    const sections = [
      {
        id: "spending-progress-bar",
        section: "spending-progress-bar",
        selector: ".shopify-section",
      },
      {
        id: "account-modal-target",
        section: "account-modal",
        selector: ".shopify-section",
      },
    ];

    const personalisationProduct = this.dataset?.personalisationProduct;
    const properties = {
      personalisation: this.dataset.propertyPersonalisation,
      color: this.dataset.propertyColor,
    };
    const items = [
      {
        id: +this.dataset.id,
        quantity: this.dataset.quantity || 1,
      },
    ];
    if (personalisationProduct) {
      items[0].properties = {
        _personalisation: +personalisationProduct,
        _personalisationLetters: this.dataset.propertyPersonalisation,
        _personalisationColor: this.dataset.propertyColor,
      };
      items.unshift({
        id: +personalisationProduct,
        quantity: 1,
        properties: {
          ...properties,
          _relatedProduct: +this.dataset.id,
          _relatedLetters: this.dataset.propertyPersonalisation,
          _relatedColor: this.dataset.propertyColor,
        },
      });
    }

    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items,
        sections: sections.map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    })
      .then(async (response) => {
        if (response.status === 200) {
          this.classList.remove("loading");
          this.classList.add("added");
          setTimeout(() => {
            this.classList.remove("added");
          }, 3000);
          if (window.location.pathname !== "/cart") {
            document.querySelector("add-to-cart-banner").open();
          }
        } else if (response.status === 422) {
          const data = await response.json();
          const message = data.message ?? `All items in size ${this.dataset.title} have been added to the cart`;
          this.classList.remove("loading");
          this.dataset.errorMessage = message;
          this.classList.add("error");
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        sections.forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
      })
      .catch((e) => console.log(e));
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)?.innerHTML;
  }
  async updateModalCartItems() {
    const cartNotification = document.querySelector("cart-notification");
    const notificationWrapper = document.querySelector(
      ".cart-notification-wrapper"
    );
    const res = await fetch("/?sections=cart-notification-product");
    const data = await res.json();
    this.classList.remove("loading");
    cartNotification.renderContents(data["cart-notification-product"]);
    cartNotification.classList.add("animate", "active");
    notificationWrapper.classList.add("active");
  }
}
customElements.define("add-to-cart", addToCart);

class addToCartModal extends HTMLElement {
  constructor() {
    super();
    this.productData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    this.btnText = this.querySelector("[data-btn-text]");
    this.card = this.closest(".card__product");
    this.cardContent = this.closest(".card__product-content");
    if (this.cardContent) {
      this.closeError = this.cardContent.querySelector("[data-close-error]");
      this.swatcherBtn = this.card.querySelector(".card__product-color--main");
      this.slider = this.cardContent.querySelector("[data-swiper-images]");
      this.modal = this.cardContent.querySelector(`[data-modal-id]`);
      if (window.innerWidth < 749) {
        this.modal = document.querySelector(`[data-modal-id="global"]`);
      }
    } else {
      this.modal = document.querySelector(
        `[data-modal-id="${this.productData.productId}"]`
      );
    }
    if (!this.modal) return;
    this.contentWrapper = this.modal.querySelector("[data-product-variants]");
    this.button = this.modal.querySelector("[data-add-to-cart]");
    this.buttonText = this.modal.querySelector("[data-add-to-cart] .btn-text");
    this.closeButtons = this.modal.querySelectorAll(`[data-close-modal]`);
    this.isPromoCollectionHidden = this.productData?.isPromoCollectionHidden;

    if (this.slider)
      this.slider = new Swiper(this.slider, {
        loop: true,
        initialSlide: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

    this.closeError &&
      this.closeError.addEventListener("click", () =>
        this.classList.remove("error")
      );
    // this.card.addEventListener("mouseover", () =>
    //   this.card.classList.add("hovered")
    // );
    if (window.innerWidth > 749) {
      this.card &&
        this.card.addEventListener("mouseleave", () => {
          this.initialCardState();
        });
    }

    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.contentWrapper.innerHTML = this.renderVariants();
      this.variants = this.modal.querySelectorAll("[data-variant-id]");
      if (this.variants.length === 1) {
        this.classList.add("loading");
        this.addToCartProduct(
          this.variants[0].dataset.variantId,
          this.variants[0],
          true
        );
      } else {
        this.openModal();
        this.variants.forEach((variant) => {
          variant.addEventListener("click", (e) => {
            e.preventDefault();
            variant.classList.add("loading");
            this.addToCartProduct(variant.dataset.variantId, variant);
          });
        });
      }
    });
    this.closeButtons.forEach((btn) =>
      btn.addEventListener("click", () => {
        this.closeModal();
      })
    );
  }
  openModal() {
    this.modal.classList.add("active");
    // document.body.classList.add("overflow");
  }
  closeModal() {
    this.modal.classList.remove("active");
    // document.body.classList.remove("overflow");
  }
  initialCardState() {
    // this.card.classList.remove("hovered");
    this.slider && this.slider.slideToLoop(1);
    this.swatcherBtn && this.swatcherBtn.dispatchEvent(new Event("click"));
    this.closeButtons[0] &&
      this.closeButtons[0].dispatchEvent(new Event("click"));
  }
  sortingSize(a, b) {
    const sizes = productSortedSizes;
    const aIdx = sizes.indexOf(a.option1.toUpperCase());
    const bIdx = sizes.indexOf(b.option1.toUpperCase());
    if (aIdx < 0 && bIdx < 0) {
      return a.option1 - b.option1;
    }

    return aIdx - bIdx;
  }
  renderVariants() {
    const filteredVariants = this.productData.variants.filter(
      (variant) => variant.available
    );
    return filteredVariants
      .sort(this.sortingSize.bind(this))
      .map((variant) => {
        return `
      <div class="add-to-cart-modal__variant" 
        data-product-id="${this.productData.productId}" 
        data-product-type="${this.productData.productType}"  
        data-variant-id="${variant.id}">
        ${variant.option1}
        <span class="error">Maximum items selected</span>
      </div>
    `;
      })
      .join("");
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  async blockedButtons() {
    const filters = document.querySelector("site-filters");
    filters.classList.add("loading");
    const res = await fetch("/cart.js");
    const cart = await res.json();
    const promoCollectionsYProducts = cart.items.filter((item) =>
      this.productData.promoCollectionsYProductsIds.some((id) => item.id === id)
    );
    const sumYProducts = promoCollectionsYProducts.reduce((a, b) => {
      return a + b.quantity;
    }, 0);
    if (sumYProducts >= this.productData.promoAmoutProducts) {
      filters
        .querySelectorAll(".add-to-cart-modal-btn")
        .forEach((el) => el.classList.add("blocked"));
    }
    filters.classList.remove("loading");
  }
  async addToCartProduct(id, variant, singleVariant) {
    const variantBtn = this.modal.querySelector(`[data-variant-id="${id}"]`);
    const spendProgressBar = document.querySelector("#spending-progress-bar");
    const sectionId =
      document.getElementById("main-cart-items")?.dataset.id || "";

    const sections = [
      {
        id: "account-modal-target",
        section: "account-modal",
        selector: ".shopify-section",
      },
    ];
    if (spendProgressBar) {
      sections.push({
        id: "spending-progress-bar",
        section: "spending-progress-bar",
        selector: ".shopify-section",
      });
    }

    if (sectionId) {
      sections.push(
        {
          id: "main-cart-items",
          section: sectionId,
          selector: ".cart-template",
        },
        {
          id: "free-promo__products",
          section: "free-promo-products",
          selector: ".shopify-section",
        }
      );
    }
    this.dataset.noAddClass &&
      document.getElementById("featured-collection") &&
      sections.push({
        id: "featured-collection",
        section: document.getElementById("featured-collection").dataset.id,
        selector: ".collection",
      });

    const items = [
      {
        id: Number(id),
        quantity: this.dataset.quantity || 1,
      },
    ];
    const personalisationProduct = this.dataset?.personalisationProduct;
    const properties = {
      personalisation: this.dataset?.propertyPersonalisation,
      color: this.dataset?.propertyColor,
    };
    if (personalisationProduct) {
      items[0].properties = {
        _personalisation: +personalisationProduct,
        _personalisationLetters: this.dataset.propertyPersonalisation,
        _personalisationColor: this.dataset.propertyColor,
      };
      items.unshift({
        id: +personalisationProduct,
        quantity: 1,
        properties: {
          ...properties,
          _relatedProduct: +this.dataset.id,
          _relatedLetters: this.dataset.propertyPersonalisation,
          _relatedColor: this.dataset.propertyColor,
        },
      });
    }
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items,
        sections: sections.map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    })
      .then(async (res) => {
        const data = await res.json();
        if (res.status === 200) {
          this.closeModal();
          this.classList.add("added");
          this.classList.remove("loading");

          setTimeout(() => {
            this.classList.remove("added");
          }, 3000);

          if (this.isPromoCollectionHidden) {
            await this.blockedButtons();
          }

          sections.forEach((section) => {
            const html = data.sections[section.section];
            const elementToReplace =
              document
                .getElementById(section.id)
                ?.querySelector(section.selector) ||
              document.getElementById(section.id);
            if (elementToReplace)
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                html,
                section.selector
              );
          });
          if (window.location.pathname === "/cart" && sectionId) {
            this.modal.classList.remove("active");
          } else {
            variantBtn.classList.remove("loading");
            document.querySelector("add-to-cart-banner").open();
          }
        } else if (res.status === 422) {
          if (singleVariant) {
            const message = data.message ?? `All items in size ${this.dataset.title} have been added to the cart`;
            this.classList.add("error");
            this.parentNode.querySelector("[data-cart-error]").innerHTML = message;
            this.classList.remove("loading");
          } else {
            variantBtn.classList.add("error");
            variantBtn.classList.remove("loading");
          }
        }
      })
      .catch((e) => console.log(e));
  }
}

customElements.define("add-to-cart-modal", addToCartModal);

class productQuantity extends HTMLElement {
  constructor() {
    super();
    this.addToCartBtns = document.querySelectorAll(
      `[data-open-add-to-cart-modal="${this.dataset.productId}"], [data-add-to-cart-id="${this.dataset.productId}"]`
    );
    this.input = this.querySelector("[data-quantity]");
    this.plusBtn = this.querySelector("[data-plus]");
    this.minusBtn = this.querySelector("[data-minus]");
    this.plusBtn?.addEventListener("click", () => this.changeQuantity(1));
    this.minusBtn?.addEventListener("click", () => this.changeQuantity(-1));
    this.input?.addEventListener("change", (e) =>
      this.updateQuantity(e.target.value)
    );
  }

  changeQuantity(amount) {
    const value = Math.max(1, (parseInt(this.input.value, 10) || 1) + amount);
    this.input.value = value;
    this.updateQuantity(this.input.value);
  }
  updateQuantity(quantity) {
    this.addToCartBtns.forEach((btn) => (btn.dataset.quantity = quantity));
  }
}

customElements.define("product-quantity", productQuantity);

class AccountModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector("#account-modal-target");
    this.clicked = true;
    this.overlay = this.querySelector(".drawer-overlay");
    this.buttonInfo = this.querySelector(".account-drawer__button-info");
    this.drawerInfo = this.querySelector(".account-drawer__info");
    this.triggerButton = document.querySelector("#account-click-trigger");
    // this.triggerButton.addEventListener("mouseover", this.open.bind(this));

    this.buttonInfo &&
      this.buttonInfo.addEventListener("click", () => {
        this.buttonInfo.classList.toggle("active");
        this.drawerInfo.classList.toggle("active");
      });

    this.overlay.addEventListener("click", this.close.bind(this));
  }

  open() {
    this.modal.classList.add("active");
  }
  close() {
    this.modal.classList.remove("active");
  }
}
customElements.define("account-modal", AccountModal);

class ProductSwatcherButton extends HTMLElement {
  constructor() {
    super();
    this.card = this.closest(".card__product");
    if (!this.card) return;
    this.allProductCards = this.closest(".card__product").querySelectorAll(
      `[data-card-product-content]`
    );
    this.allColorBtn =
      this.closest(".card__product").querySelectorAll(`.card__product-color`);
    this.productCard = this.closest(".card__product").querySelector(
      `[data-card-product-content="${this.dataset.id}"]`
    );

    this.addEventListener("click", this.open.bind(this));
  }

  open() {
    this.allColorBtn.forEach((card) => card.classList.remove("active"));
    this.allProductCards.forEach((card) => card.classList.remove("active"));
    this.productCard.classList.add("active");
    this.classList.add("active");
  }
  close() {
    this.productCard.classList.remove("active");
    this.classList.add("active");
  }
}
customElements.define("product-swatcher-button", ProductSwatcherButton);

class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.toggle.bind(this));
  }
  toggle() {
    this.classList.toggle("active");
  }
}
customElements.define("accordion-item", AccordionItem);

class ProductSizeVariants extends HTMLElement {
  constructor() {
    super();
    this.addToCartBtn = document.querySelector("#main-product add-to-cart");
    this.form = this.querySelector("form");
    this.form.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(e) {
    this.addToCartBtn.classList.remove("error");
    this.addToCartBtn.dataset.title = e.target.dataset.title;
    this.addToCartBtn.dataset.id = e.target.value;
  }
}
customElements.define("product-size-variants", ProductSizeVariants);

const swymCountElems = document.querySelectorAll("[data-swym-count]");
if (swymCountElems.length > 0) {
  const renderWishlistCounter = () => {
    swymCountElems.forEach((elem) => {
      if (window._swat.renderWishlistCount) {
        window._swat.renderWishlistCount(elem, (count) => {
          if (count >= 100) {
            elem.classList.add("big-circle");
          } else if (count == 0) {
            elem.classList.add("hidden");
          } else {
            elem.classList.remove("big-circle");
            elem.classList.remove("hidden");
          }
          return count;
        });
      }
    });
  };
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(renderWishlistCounter);
}
